import type { AtsInfoState } from "@/types/ui"
import type { AtsDestinationFieldInfo } from "@/types/fbo-api"

/**
 * Validation utility for field mappings
 */
export function validateMapping(
  destinationField: string,
  dataTypeConverter: string | null | undefined,
  availableDestinationFields: AtsDestinationFieldInfo[],
  atsInfoState: AtsInfoState
) {
  const isValidDestinationField = availableDestinationFields.some(
    field => field.FieldPath === destinationField
  )

  const isValidDataTypeConverter = !dataTypeConverter || 
    !atsInfoState.data?.supportedDataTypeConverters || // If no data loaded yet, treat as valid/unknown
    atsInfoState.data.supportedDataTypeConverters.some(
      converter => converter.name === dataTypeConverter
    )

  return {
    isValidDestinationField,
    isValidDataTypeConverter,
    hasAnyInvalidation: !isValidDestinationField || !isValidDataTypeConverter
  }
}

